var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-movie__items" }, [
    _c(
      "div",
      { staticClass: "c-movie__items__col" },
      [
        _c(
          "router-link",
          {
            staticClass: "c-link c-link--movie",
            attrs: { to: _vm.movieLink, title: _vm.item.Title }
          },
          [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value:
                    _vm.imageUrl || require("@/assets/images/yesterday.jpg"),
                  expression:
                    "imageUrl || require(`@/assets/images/yesterday.jpg`)"
                }
              ],
              staticClass: "c-movie__image",
              attrs: { alt: "" }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-movie__items__col c-movie__desc" },
      [
        _c("movie-info", {
          attrs: { showTrailer: true, "movie-detail": _vm.item }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-movie__desc__col" },
          [
            _c(
              "router-link",
              {
                staticClass: "c-btn c-btn--buy",
                attrs: {
                  to: { name: "booking", params: { title: _vm.item.Slug } },
                  title: "Book Tickets"
                }
              },
              [_vm._v("\n        Book Tickets\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }